export default class TicketlessValetService {
  constructor(client) {
    this.apiClient = client;
  }

  async getTicketDetails(credentialId) {
    return this.apiClient.get(`ticketlessvaletrequest/${credentialId}`);
  }
}
